import { render, staticRenderFns } from "./NewDeals.vue?vue&type=template&id=5c68388c&scoped=true&"
import script from "./NewDeals.vue?vue&type=script&lang=js&"
export * from "./NewDeals.vue?vue&type=script&lang=js&"
import style0 from "./NewDeals.vue?vue&type=style&index=0&id=5c68388c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68388c",
  null
  
)

export default component.exports